/* eslint-disable no-restricted-globals */
import { format, isValid } from 'date-fns';
import joinSentence from '../join_sentence';

const petType = {
  OTHER: 'Other pet(s)',
  DOG: 'Dog(s)',
  CAT: 'Cat(s)',
};

interface Child {
  name?: string;
  birthDate?: string;
}

export function dateFormatted(start: Date): string {
  return format(start, 'EEEE, MMMM d, yyyy');
}

export function timeFrame(start: Date, end: Date): string | null {
  if (!isValid(start) || !isValid(end)) return null;

  if (start.getDay() === end.getDay()) {
    if (format(start, 'a') === format(end, 'a')) {
      return `${format(start, 'h:mm')} – ${format(end, 'h:mm aaa')}`;
    }
    return `${format(start, 'h:mm aaa')} – ${format(end, 'h:mm aaa')}`;
  }

  return `${format(start, 'h:mm aaa')} – ${format(end, 'h:mm aaa (eee)')}`;
}

export function petDetails(petInfo: Array<string>): string | null {
  if (petInfo.length !== 0) {
    const pets = petInfo.map((pet: string) => petType[pet]);
    return joinSentence(pets, true);
  }

  return null;
}

export function childCount(childList: Array<Child>): string {
  const count = childList.length;
  if (count === 1) return `${count} child`;
  return `${count} children`;
}

export default {
  dateFormatted,
  timeFrame,
  petDetails,
  childCount,
};

/* eslint-disable no-restricted-globals */
